'use client'
import PrePostHarvestComponent from './PrePostHarvestComponent'

const layout = ({ children }: { children: React.ReactNode }) => {
  return <PrePostHarvestComponent tab={children} />
}

export default layout
